module.exports = __webpack_public_path__ + "static/media/muerteHoy.6a472a26.png";